// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4128":"c01d3a2a","7532":"c398c017"}[chunkId] + ".chunk.css";
};